/**
 * Appends product compare_at_price (strikethrough) to add-to-cart buttons on PDPs.
 * Uses theme money format and runs on load and after variant change.
 */
(function () {
  const COMPARE_CLASS = 'atc-compare-price';
  const VARIANT_CHANGE_DELAY_MS = 300;

  function logNoPriceDifference(context, price, compare) {
    if (compare == null || compare <= price) {
      console.log('[atc-compare-price] No price difference — compare not greater than price.', { context: context, price: price, compare: compare });
    }
  }

  function stripHtml(str) {
    if (typeof str !== 'string') return '';
    var div = document.createElement('div');
    div.innerHTML = str;
    return (div.textContent || div.innerText || '').trim();
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    const format = window.themeMoneyFormat;
    if (!format || typeof format !== 'string') {
      return (cents / 100).toFixed(2);
    }
    const amount = (cents / 100).toFixed(2);
    let out = format.replace(/\{\{\s*amount\s*\}\}/gi, amount);
    const currency = window.themeCartCurrency;
    const locale = window.themeLocale || '';
    if (currency === 'AED') {
      if (locale.indexOf('ar') !== -1) {
        out = out.replace(/\bAED\b/g, 'د.إ').replace(/\bDhs\.?\s*/gi, 'د.إ');
      } else {
        out = out.replace(/\bAED\b/g, 'Dhs.');
      }
    }
    return stripHtml(out);
  }

  function getVariantsForForm(form) {
    const section = form.closest('section');
    if (!section) return null;
    const picker = section.querySelector('variant-radios, variant-selects');
    if (picker) {
      const script = picker.querySelector('script[type="application/json"]');
      if (script) {
        try {
          return JSON.parse(script.textContent);
        } catch (_) {}
      }
    }
    const productJson = document.getElementById('ProductJson-product');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        return product.variants || null;
      } catch (_) {}
    }
    return null;
  }

  function getVariantCartMap() {
    const mapEl = document.getElementById('variant-cart-map-data');
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent);
    } catch (_) {
      return null;
    }
  }

  function getMappedAvailability(sourceVariantId, map) {
    if (!map || sourceVariantId == null) return undefined;
    const entry = map[String(sourceVariantId)];
    if (entry == null) return undefined;
    if (typeof entry === 'object' && typeof entry.available === 'boolean') {
      return entry.available;
    }
    return undefined;
  }

  function getCurrentVariantId(form) {
    const input = form.querySelector('input[name="id"]');
    if (!input) return null;
    const val = input.dataset.sourceVariantId || input.dataset.selectedId || input.value;
    return val ? String(val).trim() : null;
  }

  function updateButtonComparePrice(button, form) {
    const span = button && button.querySelector(':scope > span');
    if (!span) return;
    const variants = getVariantsForForm(form);
    if (!variants || !variants.length) return;
    const variantId = getCurrentVariantId(form);
    const variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;
    const map = getVariantCartMap();
    const mappedAvailable = getMappedAvailability(variantId, map);
    const isAvailable = mappedAvailable !== undefined ? mappedAvailable : variant.available;
    const hasCompare = variant.compare_at_price != null && variant.compare_at_price > variant.price;
    const isSoldOut = !isAvailable;
    const existing = span.querySelector('.' + COMPARE_CLASS);
    if (existing) existing.remove();
    if (hasCompare && !isSoldOut) {
      const compareSpan = document.createElement('span');
      compareSpan.className = COMPARE_CLASS;
      compareSpan.setAttribute('aria-hidden', 'true');
      // compareSpan.textContent = ' ' + formatMoney(variant.compare_at_price);
      compareSpan.innerHTML = ' <span class="money">' + formatMoney(variant.compare_at_price) + '</span>';
      span.appendChild(compareSpan);
    } else {
      logNoPriceDifference('PDP / buy-buttons', variant.price, variant.compare_at_price);
    }
  }

  function updateAllComparePrices() {
    const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    forms.forEach(function (form) {
      if (form.closest('.bundle-deals')) return;
      const button = form.querySelector('.atc-button[name="add"], .product-form__submit[name="add"]');
      if (button) {
        updateButtonComparePrice(button, form);
      }
    });
  }

  function updateBundleDealsComparePrices() {
    const sections = document.querySelectorAll('.bundle-deals');
    sections.forEach(function (section) {
      const form = section.querySelector('form[data-type="add-to-cart-form"]');
      const button = form && form.querySelector('.atc-button[name="add"], .product-form__submit[name="add"]');
      if (!form || !button) return;
      const checkboxes = section.querySelectorAll('.bundle-deals__checkbox:checked');
      let totalPriceCents = 0;
      let totalCompareCents = 0;
      checkboxes.forEach(function (cb) {
        totalPriceCents += parseInt(cb.dataset.price, 10) || 0;
        var cp = parseInt(cb.dataset.comparePrice, 10);
        if (!isNaN(cp)) totalCompareCents += cp;
      });
      const existing = button.querySelector('.' + COMPARE_CLASS);
      if (existing) existing.remove();
      if (totalCompareCents > totalPriceCents) {
        const span = button.querySelector(':scope > span');
        if (span) {
          const compareSpan = document.createElement('span');
          compareSpan.className = COMPARE_CLASS;
          compareSpan.setAttribute('aria-hidden', 'true');
          compareSpan.textContent = ' ' + formatMoney(totalCompareCents);
          compareSpan.innerHTML = ' <span class="money">' + formatMoney(totalCompareCents) + '</span>';
          span.appendChild(compareSpan);
        }
      } else {
        logNoPriceDifference('bundle-deals', totalPriceCents, totalCompareCents);
      }
    });
  }

  function updateBundleComparePrices() {
    const wrappers = document.querySelectorAll('.bundle-selector-3tabs');
    wrappers.forEach(function (wrapper) {
      const form = wrapper.querySelector('#BundleCartForm, form[action*="cart/add"]');
      const button = form && form.querySelector('.add-to-cart-btn[name="add"]');
      if (!form || !button) return;

      const variantIdInput = form.querySelector('input[name="id"]');
      const currentVariantId = variantIdInput ? String(variantIdInput.value || '').trim() : '';
      const filterVariantId = String(wrapper.dataset.filterVariantId || '').trim();
      const bundleVariantId = String(wrapper.dataset.bundleVariantId || '').trim();

      let compareCents = 0;
      let priceCents = 0;
      if (currentVariantId === filterVariantId) {
        compareCents = parseInt(wrapper.dataset.filterComparePrice, 10) || 0;
        priceCents = parseInt(wrapper.dataset.filterPriceCents, 10) || 0;
      } else if (currentVariantId === bundleVariantId) {
        compareCents = parseInt(wrapper.dataset.bundleComparePrice, 10) || 0;
        priceCents = parseInt(wrapper.dataset.bundlePriceCents, 10) || 0;
      }

      const existing = button.querySelector('.' + COMPARE_CLASS);
      if (existing) existing.remove();

      if (compareCents > priceCents) {
        const compareSpan = document.createElement('span');
        compareSpan.className = COMPARE_CLASS;
        compareSpan.setAttribute('aria-hidden', 'true');
        // compareSpan.textContent = ' ' + formatMoney(compareCents);
        compareSpan.innerHTML = ' <span class="money">' + formatMoney(compareCents) + '</span>';
        button.appendChild(compareSpan);
      } else {
        logNoPriceDifference('bundle-selector', priceCents, compareCents);
      }
    });
  }

  function init() {
    if (window.themeMoneyFormat) {
      updateAllComparePrices();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(updateAllComparePrices, VARIANT_CHANGE_DELAY_MS);
        });
      }
    }
    updateBundleComparePrices();
    updateBundleDealsComparePrices();
    window.updateAllComparePrices = updateAllComparePrices;
    window.updateBundleComparePrices = updateBundleComparePrices;
    window.updateBundleDealsComparePrices = updateBundleDealsComparePrices;
    document.querySelectorAll('.bundle-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        setTimeout(updateBundleComparePrices, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
